import projectImg from "@/assets/create-space/project.png";
import { ReactNode, forwardRef } from "react";
import { IforwardRef } from "../EditText/EditText";
import { Checkbox, Popover, Tag } from "@arco-design/web-react";
import { IconMoreVertical } from "@arco-design/web-react/icon";
import UserAvator from "../UserAvator/UserAvator";
import "./EngineerCard.less";
export interface IEngineerCard {
  title: string;
  updateTime: string;
  avatorList: { avator: string; name: string }[];
  isOperate?: boolean;
  checkBoxState?: boolean;
  actionBar?: ReactNode;
  onClick: () => void;
  handleCheckboxChange?: (e: boolean) => void;
  handleInputEndEnter?: (e: string) => void;
  type?: any
}
const EngineerType = {
  0: "魔剪",
  1: "魔剪",
  3: "图文",
  5: "云剪",
  6: "讯剪"
};

const EngineerCard = forwardRef<IforwardRef, IEngineerCard>((props, ref) => {
  const {
    onClick,
    title,
    updateTime,
    avatorList,
    actionBar,
    isOperate,
    checkBoxState,
    handleCheckboxChange,
    handleInputEndEnter,
    type
  } = props;
  return (
    <div
      className="engineer-card"
      onClick={() => {
        onClick();
      }}>
      <div className="tag-wrapper">
        <Tag
          style={{
            borderColor: "#165dff",
            background: "white",
            color: "#165dff",
          }}
          bordered>
          {
            EngineerType[type]
          }
        </Tag>
      </div>
      {isOperate ? (
        <div
          className={`engineer-checkbox-wrapper ${checkBoxState ? "show" : ""}`}>
          <Checkbox
            onClick={(e) => {
              e.stopPropagation();
            }}
            checked={checkBoxState}
            onChange={(e) => {
              if (handleCheckboxChange) {
                handleCheckboxChange(e);
              }
            }}
          />
        </div>
      ) : (
        <></>
      )}
      <img src={projectImg} alt="project Image" style={{ cursor: "pointer" }} />
      <p className="project-name">{title}</p>
      {actionBar ? (
        <Popover position="rt" content={actionBar} trigger={"hover"}>
          <div className="more-opearte" style={{ cursor: "point" }}>
            <IconMoreVertical
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </div>
        </Popover>
      ) : null}
      <p className="project-update-time">
        <UserAvator
          style={{ marginRight: "6px" }}
          background={(avatorList || [])[0]?.avator || "'"}
          name={((avatorList || [])[0]?.name || "").slice(-2)}></UserAvator>
        更新:{updateTime}
      </p>
      {/* <div className="avator-list-wrapper">
        {avatorList && avatorList.length > 0 ? (
          <>
            {avatorList.map((item, index) => {
              return (
                <Fragment key={item.name + index}>
                  <UserAvator
                    background={item.avator}
                    name={item.name.slice(-2)}></UserAvator>
                </Fragment>
              );
            })}
          </>
        ) : (
          <></>
        )}
      </div> */}
    </div>
  );
});

export default EngineerCard;
